import { useSearchParams } from "react-router-dom";
import Zones from "@/components/Zones/Zones";
import useDrawerPresentation from "@/hooks/useDrawerPresentation";

const PaceZonesPage = () => {
  const [searchParams] = useSearchParams();
  const { isDrawer, close } = useDrawerPresentation("paceZones");
  // Opened from outside settings (e.g. lobby's "Missing pace zones" prompt) there's no history
  // behind the page, so back has to close the portal rather than navigate.
  const closeOnBack = isDrawer || !!searchParams.get("from");

  return <Zones type="speed" onClose={closeOnBack ? close : undefined} />;
};

export default PaceZonesPage;
